// Importación de módulos y recursos
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import Imagen1 from "../assets/images/galeria1.webp";
import Imagen2 from "../assets/images/galeria2.webp";
import Imagen3 from "../assets/images/galeria3.webp";
import Imagen4 from "../assets/images/galeria4.webp";
import Imagen5 from "../assets/images/galeria4.webp";
import { useTranslation } from "react-i18next";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Gallery = () => {
  const images = [Imagen1, Imagen2, Imagen3, Imagen4, Imagen5];
  const { t } = useTranslation();

  return (
    <section id="galery" className="w-[90%] md:w-[100%] mx-auto lg:py-10 py-2 px-[20px] lg:px-20">
      {/* Títulos de la sección */}
      <div className="text-center mb-6">
        <h3 className="text-[22px] lg:text-[32px] font-bold text-textTitle">{t("galery.galery-title")}</h3>
        <h2 className="text-textSubtitle font-medium text-[12px] lg:text-[14px]">
          {t("galery.galery-description")}
        </h2>
      </div>

      {/* Swiper Slider */}
      <div className="relative">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={1} // Muestra 1 imagen por defecto
          navigation={{
            nextEl: ".swiper-button-next-custom",
            prevEl: ".swiper-button-prev-custom",
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            200: { slidesPerView: 1 }, // 1 imagen en pantallas pequeñas     
            768: { slidesPerView: 2 }, // 2 imágenes en tablets
            1020: { slidesPerView: 3 }, // 3 imágenes en pantallas medianas
            1280: { slidesPerView: 4 }, // 4 imágenes en pantallas grandes
          }}
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={img}
                alt={`Gallery ${index + 1}`}
                className="w-full h-[280px] object-cover rounded-xl shadow-md rotate-90"
              />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Botones de Navegación Personalizados */}
        <div className="swiper-button-prev-custom absolute lg:left-[-30px] left-[-10px] top-[40%] lg:text-4xl text-2xl text-gray-600 cursor-pointer select-none">
          ❮
        </div>
        <div className="swiper-button-next-custom absolute lg:right-[-30px] right-[-10px] top-[40%] lg:text-4xl text-2xl text-gray-600 cursor-pointer select-none">
          ❯
        </div>
      </div>

      {/* Paginación Personalizada */}
      <div className="swiper-pagination-custom mt-8"></div>
    </section>
  );
};

export default Gallery;
